import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import Chart from "./Chart"

const ModalChart = (props) => {
  const {title, body, update_modal_chart, isModal, modalTitle, sensor_data_for_modal} = props
  //const [show, setShow] = useState(false);

/*   const handleClose = () => setShow(false);
  const handleShow = () => setShow(true); */
  const handleClose = () => update_modal_chart("isModal", false);
  const handleShow = () => update_modal_chart("isModal", true);
  return (
    <>
      <style>
        {`
          .adaptive-text {
            font-size: 1.5rem;
          }
          @media (max-width: 576px) {
            .adaptive-text {
              font-size: 0.875rem;
            }
          }
        `}
      </style>
      <Modal show={isModal} onHide={handleClose}>
      <Modal.Header>
        
          <Modal.Title> <span className="adaptive-text">{modalTitle}</span> </Modal.Title>
          <Button variant="close" onClick={handleClose} aria-label="Close">
            &times; {/* Cross symbol */}
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Chart 
            data = {sensor_data_for_modal}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalChart;